import i18n from 'i18next';

// Import types
import type { RTKQueryError, AxiosErrorResponse, ValidatorErrors } from 'types/api/errors';

type Error = AxiosErrorResponse | { response: RTKQueryError };

export const convertValidatorErrors = (errors?: ValidatorErrors) => {
	if (!errors) return undefined;
	return Object.entries(errors).reduce((acc: Record<string, string>, [key, value]) => {
		acc[key] = i18n.t([`validator:${key}.${value[0]}`, 'validator:common.default.message']);
		return acc;
	}, {});
};

export const checkValidatorErrors = async ({ response }: Error) => {
	switch (response?.status) {
		case 422:
			return convertValidatorErrors(response.data?.validator?.errors);
		default:
			return undefined;
	}
};
